<!-- <div>This component does not serve as html</div> -->
<!-- <div>This component is used for navigation to respective summary page as per lob</div> -->

<div class="conf-configurator-layout">
  <div class="conf-configurator-wrapper">
    <!--##############################################################
                                MAIN LOB SECTION
            ############################################################## -->
    <div class="conf-head-wrapper">
      <div class="nav-header-section">
        <app-conf-nav-header></app-conf-nav-header>
      </div>
    </div>

    <!--##############################################################
                            HEADER SECTION (LOB SECTION TITLE)
            ############################################################## -->

    <div class="main-section-wrapper main-section-wrapper_for_predictive">
      <div class="conf-outer-main">
        <div class="conf-summary-page">
          <div class="conf-summary-inner">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="conf-page-title">
                  <p class="conf-p-center">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{ height: '50px' }"
                    ></ngx-skeleton-loader>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="conf-vehicle-name-like">
                  <h6 class="conf-veh-name">
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="{ height: '50px', width: '200px' }"
                    ></ngx-skeleton-loader>
                  </h6>
                </div>
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="{ height: '280px' }"
                ></ngx-skeleton-loader>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div id="pricescroll" class="divscroll">
                  <div class="conf-pricebreaker-wrapper pricebreaker-pc">
                    <div
                      class="conf-pricebreaker-wrapper-inner conf-pricebreaker-bg"
                      class="conf-pricebreaker-wrapper-inner-gross"
                      class="conf-pricebreaker-wrapper-inner-gross"
                    >
                      <ngx-skeleton-loader
                        count="1"
                        appearance="line"
                        [theme]="{ height: '320px' }"
                      ></ngx-skeleton-loader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
